<div viewEdit #viewEdit="viewEdit" initialState="view">
    <div class="view view-edit-show">
        <div style="display:flex;flex-direction: row;">
            <h6>
                Title
            </h6>
            <div style="flex:1;display:flex;justify-content:end">
                <nb-actions>
                    <nb-action icon="edit-outline" (click)="viewEdit.toggle()" title="Edit Name"></nb-action>
                </nb-actions>
            </div>
        </div>
        <div style="padding-bottom:0.875rem;">{{contentName}}</div>
    </div>
    <div class="edit view-edit-hide">
        <h6>
            Edit Title
        </h6>
        <form [formGroup]="form">
            <input type="text" nbInput fullWidth placeholder="Article Name" formControlName="contentName" (ngModelChange)="onChangeEvent($event)"/>
        </form>
        <div style="display:flex;flex-direction: row;padding: 0.5rem 1rem;">
            <span>&nbsp;</span>
            <div style="flex:1;display:flex;justify-content:end">
                <ng-container *ngIf="hasChanged;else nochanges">
                    <nb-actions>
                        <nb-action icon="close-outline" (click)="viewEdit.toggle()" title="Edit Name"></nb-action>
                        <nb-action icon="refresh-outline" (click)="reset()" title="reset"></nb-action>
                        <nb-action icon="checkmark-outline" (click)="submit()" title="Submit Name"></nb-action>
                    </nb-actions>
                </ng-container>
                <ng-template #nochanges>
                    <nb-actions>
                        <nb-action icon="close-outline" (click)="viewEdit.toggle()" title="Edit Name"></nb-action>
                    </nb-actions>
                </ng-template>
            </div>
        </div>
    </div>
</div>